import React from 'react'
import { Link } from 'react-router-dom'
import SuperUserPageSF from './SuperUserPageSF'

const SuperUserTxnPageUI = ({ context, className,
  topnav, backLink, headerText, subHeaderText,
  dimension, centered, children, page
}) =>
  <SuperUserPageSF
    context={context}
    className={className}
    topnav={topnav}
    backLink={backLink}
    headerText={headerText}
    subHeaderText={subHeaderText}
    dimension={dimension}
    centered={centered}
    children={children}
    sideBar={
      <SideBarUI
        page={page}
      />
    }
  />

const SideBarUI = ({ page }) =>
  <div className='t_sidebar'>
    <SideBarItemUI label='Daily Payments report' to='/su/txns/pending' active={page === 'pending'} />
    <SideBarItemUI label='Daily Transactions' to='/su/txns/daily' active={page === 'daily'} />
    <hr />
    <div className='g_m_bottom_50'>007105010733</div>
    <SideBarItemUI label='All Transactions' to='/su/txns/nodal/007105010733' active={page === '0733'} />
    <SideBarItemUI label='Reconciliation' to='/su/txns/nodal/007105010733/reconciliation' active={page === '0733recon'} />
    <SideBarItemUI label='Unreconciled' to='/su/txns/nodal/007105010733/unreconciled' active={page === '0733unrecon'} />
    <SideBarItemUI label='External' to='/su/txns/nodal/007105010733/external' active={page === '0733external'} />
    <SideBarItemUI label='Fixed Deposits' to='/su/txns/nodal/007105010733/fd' active={page === '0733fd'} />
    <SideBarItemUI label='Mutual Funds' to='/su/txns/nodal/007105010733/mutualFunds' active={page === '0733mutualFunds'} />
    <SideBarItemUI label='Cash Flow' to='/su/txns/nodal/007105010733/cashFlow' active={page === '0733cf'} />
    <SideBarItemUI label='Client-Wise Summary' to='/su/txns/nodal/007105010733/summary' active={page === '0733summary'} />
    <hr />
    <div className='g_m_bottom_50'>038605004441</div>
    <SideBarItemUI label='All Transactions' to='/su/txns/nodal/038605004441' active={page === '4441'} />
    <SideBarItemUI label='Unreconciled' to='/su/txns/nodal/038605004441/unreconciled' active={page === '4441unrecon'} />
    <SideBarItemUI label='External' to='/su/txns/nodal/038605004441/external' active={page === '4441external'} />
    <SideBarItemUI label='Fixed Deposits' to='/su/txns/nodal/038605004441/fd' active={page === '4441fd'} />
    <SideBarItemUI label='Mutual Funds' to='/su/txns/nodal/038605004441/mutualFunds' active={page === '4441mutualFunds'} />
    <SideBarItemUI label='Cash Flow' to='/su/txns/nodal/038605004441/cashFlow' active={page === '4441cf'} />
    <SideBarItemUI label='Client-Wise Summary' to='/su/txns/nodal/038605004441/summary' active={page === '4441summary'} />
    <hr />
    <div className='g_m_bottom_50'>038605004412</div>
    <SideBarItemUI label='All Transactions' to='/su/txns/clime/038605004412' active={page === '4412'} />
    <SideBarItemUI label='Unreconciled' to='/su/txns/clime/038605004412/unreconciled' active={page === '4412unrecon'} />
    <SideBarItemUI label='Fixed Deposits' to='/su/txns/clime/038605004412/fd' active={page === '4412fd'} />
    <SideBarItemUI label='Mutual Funds' to='/su/txns/clime/038605004412/mutualFunds' active={page === '4412mutualFunds'} />
  </div>

const SideBarItemUI = ({ label, to, active }) =>
  <Link to={to} className={`${active ? 'active' : ''} t_sidebar_item`}>
    {label}
  </Link>

export default SuperUserTxnPageUI

